import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CandidateStore } from "../core/services/Stores/candidate.store";
import { first } from "rxjs";

export interface IModal {
  title: string;
  text: string;
  labelButton: string;
}

@Component({
  selector: "app-privacy-data-modal",
  templateUrl: "./privacy-data-modal.component.html",
  styleUrls: ["./privacy-data-modal.component.scss"],
})

export class PrivacyDataModalComponent  {

  @Input() public modal: IModal;
  @Input() public companyId: number;

  privacyText: string;

  constructor(public activeModal: NgbActiveModal,
    public candidateStore: CandidateStore
  ) {}

  ngOnInit(): void {

    this.candidateStore.getPrivacyPolicy(this.companyId);    
  }

  closeModal() {
    this.activeModal.close();
  }
}


